
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function MusicPage() {
  const [currentlyPlaying, setCurrentlyPlaying] = useState<string | null>(null);

  // New Album: Echoes of the Dead
  const echoesAlbum = [
    {
      id: 'echoes-of-the-dead',
      title: 'Echoes of the Dead',
      image: 'https://public.readdy.ai/ai/img_res/92dabf779b289429b0a1b09b3844d5e9.jpg',
      duration: '4:28',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/echoes-of-the-dead',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/echoes-of-the-dead&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'shadows-spirits',
      title: 'Shadows & Spirits',
      image: 'https://readdy.ai/api/search-image?query=Dark%20electronic%20music%20cover%20with%20shadow%20and%20spirit%20theme%2C%20mysterious%20ghostly%20atmosphere%2C%20dark%20purple%20and%20black%20colors%2C%20supernatural%20vibes%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20dark%20EDM%20track%2C%20haunting%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=400&height=400&seq=shadows-spirits-track&orientation=squarish',
      duration: '3:52',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/shadows-spirits',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/shadows-spirits&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'the-dark-dance',
      title: 'The Dark Dance',
      image: 'https://readdy.ai/api/search-image?query=Dark%20electronic%20music%20cover%20with%20dance%20theme%2C%20mysterious%20dark%20atmosphere%2C%20black%20and%20red%20color%20scheme%2C%20gothic%20dance%20vibes%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20dark%20EDM%20dance%20track%2C%20supernatural%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=400&height=400&seq=the-dark-dance-track&orientation=squarish',
      duration: '4:15',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/the-dark-dance',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/the-dark-dance&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'muertos-after-midnight',
      title: 'Muertos After Midnight',
      image: 'https://readdy.ai/api/search-image?query=Dark%20electronic%20music%20cover%20with%20Day%20of%20the%20Dead%20theme%2C%20midnight%20atmosphere%2C%20skull%20and%20gothic%20elements%2C%20dark%20purple%20and%20orange%20colors%2C%20Mexican%20gothic%20vibes%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20dark%20EDM%20track%2C%20supernatural%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=400&height=400&seq=muertos-after-midnight-track&orientation=squarish',
      duration: '3:47',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/muertos-after-midnight',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/muertos-after-midnight&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'fiesta-eterna',
      title: 'Fiesta Eterna',
      image: 'https://readdy.ai/api/search-image?query=Dark%20electronic%20music%20cover%20with%20eternal%20party%20theme%2C%20gothic%20celebration%20atmosphere%2C%20dark%20purple%20and%20gold%20colors%2C%20mysterious%20fiesta%20vibes%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20dark%20EDM%20party%20track%2C%20supernatural%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=400&height=400&seq=fiesta-eterna-track&orientation=squarish',
      duration: '4:03',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/fiesta-eterna',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/fiesta-eterna&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    }
  ];

  const featuredTracks = [
    {
      id: 'break-the-ground',
      title: 'Break the Ground',
      image: 'https://static.wixstatic.com/media/4b4a97_cb39ec9793c14dbc817b6fc6abe1dd48~mv2.png',
      duration: '3:45',
      spotify: 'https://open.spotify.com/artist/7MWynFxiCsINwkfZHunLEU',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/break-the-ground',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/break-the-ground&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'running-free',
      title: 'Running Free',
      image: 'https://static.wixstatic.com/media/4b4a97_ee198727a29f4408a24d4beabddbdf74~mv2.png',
      duration: '3:22',
      spotify: 'https://open.spotify.com/artist/7MWynFxiCsINwkfZHunLEU',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/running-free',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/running-free&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'when-we-loved',
      title: 'When We Loved',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20cover%20art%20with%20emotional%20theme%2C%20romantic%20atmosphere%2C%20purple%20and%20pink%20gradient%20colors%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20melodic%20EDM%20track%2C%20love%20theme%20artwork%20with%20simple%20clean%20background&width=400&height=400&seq=track-when-we-loved-v2&orientation=squarish',
      duration: '4:12',
      spotify: 'https://open.spotify.com/artist/7MWynFxiCsINwkfZHunLEU',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/dj-jcb-when-we-loved-1',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/dj-jcb-when-we-loved-1&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    }
  ];

  const moreTracks = [
    {
      id: 'summer-song',
      title: 'Summer Song',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20cover%20art%20with%20summer%20theme%2C%20bright%20sunny%20atmosphere%2C%20warm%20orange%20and%20yellow%20colors%2C%20beach%20vibes%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20summer%20EDM%20track%2C%20tropical%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=300&height=300&seq=track-summer-song-v2&orientation=squarish',
      duration: '3:28',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/summer-song',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/summer-song&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'firestarter-hearts',
      title: 'Firestarter Hearts (EDM Love Anthem)',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20cover%20art%20with%20fire%20and%20heart%20theme%2C%20passionate%20love%20anthem%2C%20red%20and%20orange%20flame%20colors%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20EDM%20love%20song%2C%20romantic%20fire%20theme%20artwork%20with%20simple%20clean%20background&width=300&height=300&seq=track-firestarter-hearts-v2&orientation=squarish',
      duration: '4:05',
      soundcloud: 'https://on.soundcloud.com/e18NYUJvOU2dC8MoeL',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/firestarter-hearts-edm-love-anthem&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    },
    {
      id: 'sun-up-stay-on',
      title: 'Sun Up, Stay On',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20cover%20art%20with%20sunrise%20theme%2C%20energetic%20morning%20vibes%2C%20bright%20yellow%20and%20orange%20sunrise%20colors%2C%20modern%20digital%20art%20style%2C%20perfect%20for%20uplifting%20EDM%20track%2C%20dawn%20electronic%20music%20artwork%20with%20simple%20clean%20background&width=300&height=300&seq=track-sun-up-stay-on-v2&orientation=squarish',
      duration: '3:51',
      soundcloud: 'https://soundcloud.com/dj-jean-claude-bastos/sun-up-stay-on',
      embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/dj-jean-claude-bastos/sun-up-stay-on&color=%2362D6DF&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
    }
  ];

  const handleTrackClick = (trackId: string) => {
    if (currentlyPlaying === trackId) {
      setCurrentlyPlaying(null);
    } else {
      setCurrentlyPlaying(trackId);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <SEOHead 
        title="Music | Jean-Claude Bastos - Latest EDM Tracks & Electronic Releases"
        description="Explore Jean-Claude Bastos' complete music catalog. Stream and discover the latest EDM tracks including Break the Ground, Running Free, When We Loved, and more progressive house anthems."
      />
      <Navigation />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: '"Orbitron", sans-serif' }}>Music</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" style={{ fontFamily: '"Exo 2", sans-serif' }}>
              Discover the latest releases and tracks from Jean-Claude Bastos
            </p>
          </div>
        </div>
      </section>

      {/* New Album: Echoes of the Dead */}
      <section className="py-20 bg-gradient-to-br from-purple-900 via-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              <span className="bg-gradient-to-r from-purple-400 to-red-500 bg-clip-text text-transparent">
                NEW ALBUM
              </span>
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              ECHOES OF THE DEAD
            </h3>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" style={{ fontFamily: '"Exo 2", sans-serif' }}>
              A haunting journey through dark electronic soundscapes and supernatural rhythms
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {echoesAlbum.map((track) => (
              <div key={track.id} className="bg-gradient-to-br from-purple-900/50 to-black/80 rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all transform hover:scale-105 cursor-pointer border border-purple-500/30">
                {currentlyPlaying === track.id ? (
                  <div className="h-64 w-full">
                    <iframe
                      width="100%"
                      height="256"
                      scrolling="no"
                      frameBorder="no"
                      allow="autoplay"
                      src={track.embedUrl}
                      title={track.title}
                      className="rounded-t-2xl"
                    ></iframe>
                  </div>
                ) : (
                  <div className="relative">
                    <img 
                      src={track.image} 
                      alt={track.title}
                      className="w-full h-64 object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent hover:from-black/80 transition-all flex items-center justify-center opacity-0 hover:opacity-100">
                      <button 
                        onClick={() => handleTrackClick(track.id)}
                        className="bg-gradient-to-r from-purple-600 to-red-600 hover:from-purple-700 hover:to-red-700 text-white w-16 h-16 rounded-full flex items-center justify-center transition-all transform hover:scale-110 cursor-pointer shadow-2xl"
                      >
                        <i className="ri-play-fill text-2xl"></i>
                      </button>
                    </div>
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-black text-white mb-3 tracking-wide" style={{ fontFamily: '"Rajdhani", sans-serif' }}>{track.title.toUpperCase()}</h3>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-sm font-bold text-purple-400" style={{ fontFamily: '"Orbitron", sans-serif' }}>
                      Duration: {track.duration}
                    </span>
                    <button
                      onClick={() => handleTrackClick(track.id)}
                      className={`${
                        currentlyPlaying === track.id
                          ? 'text-purple-400'
                          : 'text-gray-400'
                      } hover:text-purple-400 transition-colors cursor-pointer transform hover:scale-125`}
                    >
                      <i
                        className={`text-xl ${
                          currentlyPlaying === track.id
                            ? 'ri-stop-circle-fill'
                            : 'ri-play-circle-line'
                        }`}
                      ></i>
                    </button>
                  </div>
                  <a 
                    href={track.soundcloud} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center text-sm"
                    style={{ fontFamily: '"Rajdhani", sans-serif' }}
                  >
                    <i className="ri-soundcloud-line mr-2 text-lg"></i>
                    Play on SoundCloud
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Releases */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              <span className="bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">
                LATEST RELEASES
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {featuredTracks.map((track) => (
              <div key={track.id} className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all transform hover:scale-105 cursor-pointer border border-gray-100">
                {currentlyPlaying === track.id ? (
                  <div className="h-72 w-full">
                    <iframe
                      width="100%"
                      height="288"
                      scrolling="no"
                      frameBorder="no"
                      allow="autoplay"
                      src={track.embedUrl}
                      title={track.title}
                      className="rounded-t-2xl"
                    ></iframe>
                  </div>
                ) : (
                  <div className="relative">
                    <img 
                      src={track.image} 
                      alt={track.title}
                      className="w-full h-72 object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent hover:from-black/80 transition-all flex items-center justify-center opacity-0 hover:opacity-100">
                      <button 
                        onClick={() => handleTrackClick(track.id)}
                        className="bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white w-20 h-20 rounded-full flex items-center justify-center transition-all transform hover:scale-110 cursor-pointer shadow-2xl"
                      >
                        <i className="ri-play-fill text-3xl"></i>
                      </button>
                    </div>
                  </div>
                )}
                <div className="p-8">
                  <h3 className="text-2xl font-black text-gray-900 mb-3 tracking-wide" style={{ fontFamily: '"Rajdhani", sans-serif' }}>{track.title.toUpperCase()}</h3>
                  <div className="flex items-center justify-between mb-6">
                    <span className="text-lg font-bold text-purple-600" style={{ fontFamily: '"Orbitron", sans-serif' }}>
                      Duration: {track.duration}
                    </span>
                    <button
                      onClick={() => handleTrackClick(track.id)}
                      className={`${
                        currentlyPlaying === track.id
                          ? 'text-cyan-500'
                          : 'text-gray-400'
                      } hover:text-cyan-500 transition-colors cursor-pointer transform hover:scale-125`}
                    >
                      <i
                        className={`text-2xl ${
                          currentlyPlaying === track.id
                            ? 'ri-stop-circle-fill'
                            : 'ri-play-circle-line'
                        }`}
                      ></i>
                    </button>
                  </div>
                  <div className="space-y-3">
                    <a 
                      href={track.spotify} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="w-full bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
                      style={{ fontFamily: '"Rajdhani", sans-serif' }}
                    >
                      <i className="ri-spotify-line mr-2 text-xl"></i>
                      Play on Spotify
                    </a>
                    <a 
                      href={track.soundcloud} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 px-4 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
                      style={{ fontFamily: '"Rajdhani", sans-serif' }}
                    >
                      <i className="ri-soundcloud-line mr-2 text-xl"></i>
                      Play on SoundCloud
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* More Tracks */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Orbitron", sans-serif' }}>MORE TRACKS</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {moreTracks.map((track) => (
              <div key={track.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer">
                {currentlyPlaying === track.id && track.embedUrl ? (
                  <div className="h-48 w-full">
                    <iframe
                      width="100%"
                      height="192"
                      scrolling="no"
                      frameBorder="no"
                      allow="autoplay"
                      src={track.embedUrl}
                      title={track.title}
                      className="rounded-t-lg"
                    ></iframe>
                  </div>
                ) : (
                  <div className="relative">
                    <img 
                      src={track.image} 
                      alt={track.title}
                      className="w-full h-48 object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 hover:opacity-100 transition-all flex items-center justify-center">
                      {track.embedUrl ? (
                        <button 
                          onClick={() => handleTrackClick(track.id)}
                          className="bg-white text-black w-12 h-12 rounded-full flex items-center justify-center transition-all transform hover:scale-110 cursor-pointer shadow-lg"
                        >
                          <i className={`text-xl ${currentlyPlaying === track.id ? 'ri-stop-fill' : 'ri-play-fill'}`}></i>
                        </button>
                      ) : (
                        <a 
                          href={track.soundcloud} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="bg-white text-black w-12 h-12 rounded-full flex items-center justify-center transition-all transform hover:scale-110 cursor-pointer shadow-lg"
                        >
                          <i className="ri-external-link-line text-xl"></i>
                        </a>
                      )}
                    </div>
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: '"Rajdhani", sans-serif' }}>{track.title}</h3>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-600 text-sm" style={{ fontFamily: '"Orbitron", sans-serif' }}>Duration: {track.duration}</p>
                    {track.embedUrl && (
                      <button
                        onClick={() => handleTrackClick(track.id)}
                        className={`${
                          currentlyPlaying === track.id
                            ? 'text-cyan-500'
                            : 'text-gray-400'
                        } hover:text-cyan-500 transition-colors cursor-pointer transform hover:scale-125`}
                      >
                        <i
                          className={`text-xl ${
                            currentlyPlaying === track.id
                              ? 'ri-stop-circle-fill'
                              : 'ri-play-circle-line'
                          }`}
                        ></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
